import * as React from "react";
import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import * as XLSX from "xlsx";
import * as JSZip from "jszip";
import {DataGrid} from "@mui/x-data-grid";
import {Table, TableBody, TableCell, TableContainer, TableRow} from "@mui/material";
import {PARSE_FIELDS} from "../utils/constants";

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

export default function InputFileUpload({ setFile, rule }) {
  const [fileContents, setFileContents] = React.useState([]);
  const [preview, setPreview] = React.useState(false);
  const [fileName, setFileName] = React.useState("");
  const [cols, setCols] = React.useState([]);

  const handleFileChange = async (event) => {
    setPreview(false);
    const file = event.target.files[0];
    if (
      file.type ===
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
      file.type === "application/vnd.ms-excel"
    ) {
      // console.log(file);
      setFile(file);
      setFileName(file.name);
      // const blob = file.slice(0, 10240);
      // const buffer = await blob.arrayBuffer();
      const buffer = await file.arrayBuffer();
      const wb = XLSX.read(buffer, {
        type: 'array',
        sheetRows: 4,
        dense: true
      });

      console.log(wb);

      const worksheet = wb.Sheets[wb.SheetNames[0]];
      const rows = XLSX.utils.sheet_to_json(worksheet, {
        header: 1,
        defval: '',
        range: 1
      });

      let cols = [];
      for (let i = 0; i < rows[0].length; i++) {
        cols.push({
          field: "field" + i,
          headerName: i + 1,
          width: 100,
          editable: false,
          sortable: false,
        });
      }

      let files = rows.map((item, index)=>{
        let colItems = {};
        for (let j = 0; j < item.length; j++) {
          colItems['field' + j] = item[j];
        }
        return {...colItems, id: index}
      });
      console.log(cols,files);

      setFileContents(files);
      setPreview(true);
    } else {
      alert("Please select an Excel file.");
    }


  };

  const getSecondRowFromXLSX = async (file) => {
    // XLSX - это ZIP архив. Читаем только XML с данными первого листа
    const entryName = 'xl/worksheets/sheet1.xml';

    // Распаковываем только нужный файл
    const zip = new JSZip();
    await zip.loadAsync(file.slice(0, Math.min(file.size, 50000))); // Читаем начало архива

    const sheetXml = await zip.file(entryName)?.async('text');
    if (!sheetXml) return [];

    // Примитивный парсинг XML
    const parser = new DOMParser();
    const xmlDoc = parser.parseFromString(sheetXml, 'text/xml');

    // Ищем вторую строку (row с индексом 2)
    const rows = xmlDoc.getElementsByTagName('row');
    for (let row of rows) {
      if (row.getAttribute('r') === '2') {
        const cells = row.getElementsByTagName('c');
        const rowData = [];
        for (let cell of cells) {
          const value = cell.getElementsByTagName('v')[0]?.textContent || '';
          rowData.push(value);
        }
        return rowData;
      }
    }

    return [];
  }

  console.log(fileContents);

  const listRow = (row, key)=>{
    let rowData = [];
    for (const rowKey in row) {
      rowData.push(<TableCell style={{
        borderBottom: 0,
        borderTop: "1px solid grey",
        borderRight: "1px solid grey",
        borderLeft: "1px solid grey",
      }}>
        <Box color={'#000000'}>{row[rowKey]}</Box>
      </TableCell>);
    }
    return <TableRow key={key}>
      {rowData}
    </TableRow>
  }

  const rulesCells = ()=>{
    let result = null;
    if(rule){
      result = [];
      for (const ruleKey in rule) {
        console.log(rule[ruleKey], ruleKey);
        if(rule[ruleKey]){
          result[parseInt(rule[ruleKey]) - 1] = <TableCell style={{
            borderBottom: 0,
            borderTop: "1px solid grey",
            borderRight: "1px solid grey",
            borderLeft: "1px solid grey",
            backgroundColor: "#95e895"
          }}><Box
              color={'#000000'}
          >{PARSE_FIELDS[ruleKey]}</Box></TableCell>;
        }
      }
      for (let i = 0; i < result.length - 1; i++) {
        console.log(result[i]);
        if(!result[i]){
          result[i] = <TableCell style={{
            borderBottom: 0,
            borderTop: "1px solid grey",
            borderRight: "1px solid grey",
            borderLeft: "1px solid grey",
          }}></TableCell>;
        }
      }
      console.log(result);
      result = <TableRow>{result}</TableRow>;
    }

    return result;
  }
  const list = ()=>{
    return (<Table>
      {rulesCells()}
      {fileContents.map((item, index) => listRow(item, index))}
    </Table>)
  }

  return (
    <>
      <Button
        component="label"
        role={undefined}
        variant="contained"
        tabIndex={-1}
        startIcon={<CloudUploadIcon />}
      >
        Загрузить файл
        <VisuallyHiddenInput
          type="file"
          onChange={handleFileChange}
          accept=".xlsx, .xls"
        />
      </Button>
      {preview && <h3>{fileName}</h3>}
      {preview && (
        <Box
          style={{
            backgroundColor: "white",
            color: "black",
          }}
          p={1}
        >
          <Box>
            <TableContainer>
              <Table className={'upload_table'} size="small">
                <TableBody>
                  {list()}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </Box>
      )}
    </>
  );
}
